import { LogoMark } from "@/components/Logo";

const ITEMS = [
  "Good coffee. Great causes.",
  "22p of every cup to charity",
  "Zero cost to hosts",
  "We install · stock · service",
  "You pick the charity",
  "Specialty bean-to-cup coffee",
  "Updated every Monday",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="bg-[#0F2E23] border-y border-white/10 py-4 overflow-hidden" aria-hidden="true">
    <div className="flex w-max animate-marquee gap-10">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10 text-sm font-display font-bold uppercase tracking-[0.18em] text-[#FAF9F6]/70 whitespace-nowrap">
          {item}
          <LogoMark className="w-5 h-5 opacity-60" />
        </span>
      ))}
    </div>
  </div>
);
